module.exports = __webpack_public_path__ + "static/media/youtube.e186a6d5.png";